import { dayInMilliseconds } from 'utils/utils';
import dates from 'utils/dates';
import Immutable from 'immutable';
import { MONTH_FLEXIBILITY_VALUE } from 'constants/searchUnit';

const privateUtils = {
  getAnnualAvailabilityWithJustOneMonth(props, calDate) {
    const { annualAvailability } = props;
    const calDateDate = dates.utcDate(calDate * dayInMilliseconds);
    const selectedYear = calDateDate.getFullYear();
    const selectedMonth = calDateDate.getMonth();
    const monthAvailability = annualAvailability.getIn([`${selectedYear}`, `${selectedMonth}`]);
    const annualAvailabilityJS = {};
    annualAvailabilityJS[selectedYear] = {};
    annualAvailabilityJS[selectedYear][selectedMonth] = monthAvailability;

    return Immutable.fromJS(annualAvailabilityJS);
  },

  isInRange(dayStamp, compareDayStamp, flex) {
    return (dayStamp >= compareDayStamp - flex) && (dayStamp <= compareDayStamp + flex);
  },

  getCheapestCalDate(props, options = {}) {
    const availability = options.availability || props.annualAvailability;
    const cheapestDay = {};

    const yearKeys = availability.keySeq().toArray().filter(item => Number(item));

    yearKeys.sort().forEach((yearKey) => {
      const monthKeys = availability.get(`${yearKey}`).keySeq().toArray();

      monthKeys.sort().forEach((monthKey) => {
        const annualAvailabilityMonth = availability.getIn([`${yearKey}`, `${monthKey}`]);

        if (annualAvailabilityMonth) {
          const dayKeys = annualAvailabilityMonth.keySeq().toArray();

          dayKeys.sort().forEach((dayKey) => {
            const price = annualAvailabilityMonth.get(`${dayKey}`);
            const date = Date.UTC(yearKey, monthKey, dayKey);
            const dayStamp = date / dayInMilliseconds;

            if (!options.flexibility || (options.flexibility && this.isInRange(options.deptDate, dayStamp, options.flexibility))) {
              if (!cheapestDay.price || price && price < cheapestDay.price) {
                cheapestDay.price = price;
                cheapestDay.calDate = dayStamp;
              }
            }
          });
        }
      });
    });

    return cheapestDay.calDate;
  },

  calculateCalDate(props) {
    const { baseState } = props;
    const flexibility = baseState.getIn(['queryState', 'props', 'deptDateFlexibility', 'value']);
    let calDate;

    if (baseState.getIn(['queryState', 'props', 'calDate', 'selected'], false)) {
      calDate = baseState.getIn(['queryState', 'props', 'calDate', 'value']);
    }

    if (!calDate && baseState.getIn(['queryState', 'props', 'deptDate', 'selected'])) {
      calDate = baseState.getIn(['queryState', 'props', 'deptDate', 'value']);

      if (calDate && flexibility === MONTH_FLEXIBILITY_VALUE) {
        const availability = this.getAnnualAvailabilityWithJustOneMonth(props, calDate);
        calDate = this.getCheapestCalDate(props, { availability });
      } else if (calDate && flexibility && flexibility > 0) {
        calDate = this.getCheapestCalDate(props, { deptDate: calDate, flexibility });
      }
    }

    // Cheapest day out of all months in all years
    if (!calDate) {
      calDate = this.getCheapestCalDate(props);
    }

    return calDate;
  },
};

export { privateUtils };

const api = {
  calculateCalDate(props) {
    return privateUtils.calculateCalDate(props);
  },

  calculateDPCalDate(props) {
    const { location } = props;

    // calDate from path. caldate - in case caldate is lowercase in path
    return location.query.calDate || location.query.caldate || privateUtils.calculateCalDate(props);
  },

  calculateFlightOnlyCalDate(props) {
    return privateUtils.calculateCalDate(props);
  },
};

export default api;



/** WEBPACK FOOTER **
 ** ./src/utils/panda.js
 **/